import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "pt-12 pb-32 lg:pb-10 px-6 lg:px-12 flex flex-col flex-col-reverse lg:flex-row max-w-screen-2xl mx-auto justify-between" }
const _hoisted_2 = { class: "text-left justify-start lg:pt-0 pt-6" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "font-poppins text-md font-thin text-white my-0 py-1" }
const _hoisted_5 = { class: "text-right justify-end flex flex-col lg:flex-row pt-0 lg:pt-2" }
const _hoisted_6 = {
  key: 0,
  class: "text-white pl-4 lg:block hidden"
}

import { DefineComponent, ref } from 'vue';
import { injectStrict } from '@/plugins/vueServiceContainerPlugin';
import { BrandServiceInterface } from '@/services/brand/brandServiceInterface';
import { Brand } from '../../services/integration/enums';

type MainLink = {
  name: string,
  href: string
}

type SocialLink = {
  name: string,
  href: string,
  icon: DefineComponent
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Footer',
  props: {
    main: {},
    social: {}
  },
  setup(__props: any) {

const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');



const brandTitle = brandService.getTitle();
const year = ref(new Date().getFullYear());


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", {
    class: _normalizeClass([_unref(brandService).getName() === _unref(Brand).HIS ? 'bg-brand-secondary' : 'bg-black', "w-full"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          class: "h-6 w-auto pr-10",
          src: _unref(brandService).getLogoDark()
        }, null, 8, _hoisted_3),
        _cache[0] || (_cache[0] = _createElementVNode("img", {
          class: "h-11 w-auto",
          src: "https://uniti-bpo-website-assets.assets.unitiinternet.com/NEX/unitigroupsm.png"
        }, null, -1)),
        _createElementVNode("p", _hoisted_4, "© " + _toDisplayString(year.value) + " • " + _toDisplayString(_unref(brandTitle)) + " • All rights reserved.", 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.main, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "lg:px-2 py-2 flex-row flex text-right justify-start"
          }, [
            _createVNode(_component_router_link, {
              to: item.href,
              class: "text-sm text-white no-underline font-poppins font-normal"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.name), 1)
              ]),
              _: 2
            }, 1032, ["to"]),
            (index < _ctx.main.length - 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, " | "))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ])
  ], 2))
}
}

})